import React, {useMemo, useRef} from 'react'

import {DrawerContext} from './context'
import {IDrawerContext} from './types'

type Props = {
  // есть проблема с коллизией zIndex между модалкой и шторкой
  // чтобы была возможность управлять что что перекрывает добавил пропс
  zIndex?: number
  className?: string
}

const DrawerOverlay: React.FC<React.PropsWithChildren<Props>> = ({zIndex = 9999, className, children}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const contextState = useMemo<IDrawerContext>(
    () => ({
      containerRef,
      contentRef,
    }),
    [],
  )

  return (
    <DrawerContext.Provider value={contextState}>
      {/* TODO: вот это вообще хрень полная */}
      {/*       потому что в провайдере создается неявный див со стилями, а они нужны */}
      <div ref={contentRef} className={className}>
        {children}
      </div>
      {/* TODO: не очень хорошо */}
      <div ref={containerRef} style={{zIndex, position: 'relative'}} />
    </DrawerContext.Provider>
  )
}

export default DrawerOverlay
